export type SummaryData = {
	label: string;
	content: string;
	iconMapper: string;
	type: SummaryType;
};

export enum LoadingState {
	INIT = "init",
	IN_PROGRESS = "in_progress",
	DONE = "done",
	ERROR = "error",
}

export enum SummaryType {
	AWARD = "award",
	TIME = "time",
	LAMP = "lamp",
	TAG = "tag",
}

export enum RoomStatus {
	READY = "ready",
	IN_GAME = "in_game",
	PAUSED = "paused",
	DONE = "done",
	AWAITING = "awaiting",
	ISSUE = "issue",
	FAILED = "failed",
}

export enum UserRole {
	PLAYER = "player",
	ADMIN = "admin",
	MODERATOR = "moderator",
	SUPER_ADMIN = "super admin",
}

export enum UserAvailability {
	PRESENT = "present",
	ABSENT = "absent",
}
